import { useEffect, useState } from "react";
import { fetchPurchaseOrdersAll, downloadPurchaseOrdersExcel } from "../Api/ViewPurchaseOrder";
import { Container, Table, Button, ButtonGroup } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { Base_URL } from "../url";
import { useNavigate } from "react-router-dom"; // 👈 add this

const ViewPurchaseOrder = () => {
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate(); // 👈 init

  useEffect(() => {
    const loadPurchaseOrders = async () => {
      try {
        const data = await fetchPurchaseOrdersAll();
        setPurchaseOrders(data || []);
      } catch (error) {
        toast.error("🦄 Error Fetching Purchase Orders");
      }
    };
    loadPurchaseOrders();
  }, [refresh]);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadPurchaseOrdersExcel();
      if (!response.data) throw new Error("No data received from server");

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Purchase_Orders_Data.xlsx");
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);

      toast.success("Purchase orders data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleCancel = async (id) => {
    try {
      const res = await axios.put(`${Base_URL}/PurchaseOrder/cancelPurchaseOrder/id?id=${id}`);
      if (res.status === 200) {
        toast.success(`${id} Purchase Order Cancelled Successfully`);
        setRefresh((prev) => !prev);
      } else {
        toast.error("Error Cancelling Purchase Order");
      }
    } catch (error) {
      toast.error("Error Cancelling Purchase Order");
      console.error(error);
    }
  };

  const handleView = (id) => {
    navigate(`/purchase-orders/${id}`); // 👈 route to details page
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="list-container">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="list-title">View Purchase Orders</h2>
            <Button
              className="generate-btn"
              variant="primary"
              onClick={handleDownload}
              disabled={isDownloading || purchaseOrders.length === 0}
            >
              {isDownloading ? "Downloading..." : "Download Data"}
            </Button>
          </div>

          {purchaseOrders.length > 0 ? (
            <div
              style={{
                maxHeight: "500px",
                overflowY: "auto",
                border: "1px solid #dee2e6",
                borderRadius: "8px",
              }}
            >
              <Table bordered hover responsive className="data-table mb-0">
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "#f8f9fa",
                    zIndex: 2,
                  }}
                >
                  <tr>
                    
                    <th>Purchase Order Number</th>
                    <th>PO Type</th>
                    <th>Merchant Code</th>
                    <th>PO Date</th>
                    <th>Currency</th>
                
                    <th>Created By</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {purchaseOrders.map((po, index) => (
                    <tr key={index}>
                      
                      <td>{po.purchaseOrderNumber}</td>
                      <td>{po.pO_type}</td>
                      <td>{po.merchantCode}</td>
                      <td>{po.pO_Date ? moment(po.pO_Date).format("L") : "N/A"}</td>
                      <td>{po.currencyCode}</td>
                      
                      <td>{po.createdBy}</td>
                      <td>{po.status}</td>
                      <td>
                        <ButtonGroup size="sm">
                          <Button
                            variant="secondary"
                            onClick={() => handleView(po.purchaseOrderNumber)}
                          >
                            View
                          </Button>
                          <Button
                            variant="danger"
                            onClick={() => handleCancel(po.purchaseOrderNumber)}
                            disabled={po.status === "Cancelled"}
                          >
                            Cancel
                          </Button>
                        </ButtonGroup>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <p className="no-data">No purchase orders found.</p>
          )}
        </Container>
      </div>
    </>
  );
};

export default ViewPurchaseOrder;
